
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Admin from "@/pages/Admin";
import Auth from "@/pages/Auth";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import EmployeeLogin from "@/pages/EmployeeLogin";
import Index from "@/pages/Index";
import NotFound from "@/pages/NotFound";
import Profile from "@/pages/Profile";
import UpdatePassword from "@/pages/UpdatePassword";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/employee-login" element={<EmployeeLogin />} />
        <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </Router>
  );
}

export default App;
